import React, { useState, useEffect, useRef } from "react";

import { useHistory, useRouteMatch, Link, NavLink, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { OverlayTrigger, Popover, Nav, Dropdown } from "react-bootstrap";

import Truncate from "react-truncate";

import cx from "classnames";
import _ from "lodash";

import styles from "./applicationMenu.module.scss";
import userRoleService from "services/userRoles.service";

export default function ApplicationMenu(props) {
  const history = useHistory();
  const locationData = useLocation()
  let { path, url } = useRouteMatch();

  const profile = useSelector((state) => _.get(state, "users.me", null));
  const [create, setCreate] = useState(false);
  const workspaces = useSelector((state) => _.get(state, "workspaces.items", null));

  const renderIcon = () => {
    return _.get(profile, "icon.thumbnail", null);
  };

  const renderUserName = () => {
    if (!profile) {
      return false;
    }

    return _.get(profile, 'firstName').concat(" ", _.get(profile, 'lastName'));
  }

  const popover = (
    <Popover id="popover-basic" className={styles.tooltip}>
      <div className={styles.userDetails}>
        <img
          className={styles.userIcon}
          src={renderIcon()}
          alt="/images/profile/default_user_profile_background.png"
        />
        <h1 className={styles.userName}>{renderUserName()}</h1>
      </div>
      <div className={styles.userMenus}>
        <Link className={styles.userMenu} onClick={() => document.body.click()} to={`${url}/settings/user-profile`}>
          User Profile
        </Link>
        <Link className={styles.userMenu} onClick={() => document.body.click()} to={{ pathname: "https://app.paperflite.com/privacy" }} target="_blank">
          Privacy Policy
        </Link>
        <Link className={styles.userMenu} onClick={() => document.body.click()} to={{ pathname: "https://app.paperflite.com/terms/" }} target="_blank">
          Terms &amp; Conditions
        </Link>
      </div>
      <div onClick={() => history.replace("/logout")} className={styles.logout}>
        <span>Log Out</span>
      </div>
    </Popover>
  );

  const WorkspaceDropdown = ({ }) => {
    const history = useHistory();

    const activeWorspace = useSelector(state => _.get(state, `workspaces.workspace.item`));

    const handleChange = (workspace) => {
      window.location.replace(`/app/${workspace.id}/storyboards`);
    }

    return (
      <Dropdown className={styles.pageDropDown}>
        <Dropdown.Toggle>
          <span className={styles.name}>
            <Truncate lines={1}>
              {_.get(activeWorspace, "name")}
            </Truncate>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {workspaces.map((workspace) => {
            const active = workspace.id === _.get(activeWorspace, 'id');
            return (
              <Dropdown.Item active={active} key={workspace.uid} onClick={() => handleChange(workspace)}>
                <span className={styles.name}>
                  <Truncate lines={1}>
                    {workspace.name}
                  </Truncate>
                </span>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  const checkActive = () => {
    if (!locationData) {
      return false;
    }
    const { pathname } = locationData;
    return _.includes(pathname, 'integration-settings') ? true : false;
  };

  const settingsUrl = () => {
    var settingUrl = `${url}/integration-settings/integration`;

    if (userRoleService.canManageUsers()) {
      settingUrl = `${url}/integration-settings/user-management`;
    }

    return settingUrl;
  }

  return (
    <>
      <div className={styles.header}>
        <div className={styles.logoContainer}>
          <div className={styles.logo}></div>
        </div>
        <div className={styles.mainMenu}>
          <Nav>
            <NavLink as={Link}
              className={styles.menuItem}
              activeClassName={styles.active} to={`${url}/storyboards`}>Storyboards</NavLink>
          </Nav>
          <Nav>
            <NavLink as={Link}
              className={cx(styles.menuItem, styles.settingButton)}
              activeClassName={styles.active} isActive={checkActive} exact to={settingsUrl()}>Workspace Settings</NavLink>
          </Nav>
        </div>

        {workspaces.length > 1 &&
          <div className={styles.mainMenu}>
            <WorkspaceDropdown />
          </div>
        }

        <div className={styles.subMenu}>
          <OverlayTrigger
            trigger="click"
            placement="bottom-end"
            rootClose={true}
            overlay={popover}
          >
            <div className={styles.avatar}>
              <img src={renderIcon()} alt={renderUserName()} />
            </div>
          </OverlayTrigger>
        </div>
      </div>
    </>
  );
}